// Angular import
import { AfterViewInit, Component, effect, HostListener, inject, OnInit } from '@angular/core';
import { CommonModule, Location, LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';

// Project import
import { BerryConfig } from 'src/app/app-config';
import { ThemeService } from '../../shared/service/theme.service';
import { SharedModule } from '../../shared/shared.module';
import { ConfigurationComponent } from './configuration/configuration.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { AtlasWidgetComponent } from '../../shared/components/atlas/atlas-widget.component';

@Component({
  selector: 'app-admin',
  imports: [
    CommonModule,
    SharedModule,
    NavigationComponent,
    NavBarComponent,
    ConfigurationComponent,
    RouterModule,
    BreadcrumbComponent,
    AtlasWidgetComponent
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent implements OnInit, AfterViewInit {
  private location = inject(Location);
  private locationStrategy = inject(LocationStrategy);
  private themeService = inject(ThemeService);
  cdr = inject(ChangeDetectorRef);

  // public props
  layouts = BerryConfig.layout;
  currentLayout!: string;
  navCollapsed: boolean = true;
  navCollapsedMob = false;
  windowWidth!: number;

  // Constructor
  constructor() {
    effect(() => {
      this.isThemeLayout(this.themeService.themeLayout());
    });
  }

  // life cycle hook
  ngOnInit() {
    this.themeService.isLandingPage.set(false);
  }

  ngAfterViewInit() {
    this.currentLayout = BerryConfig.layout;
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }

    if (current_url === baseHref + '/layout/theme-compact' || current_url === baseHref + '/layout/box') {
      BerryConfig.isCollapse_menu = true;
    }

    this.windowWidth = window.innerWidth;
    this.navCollapsed = this.windowWidth >= 1025 ? BerryConfig.isCollapse_menu : false;
    this.cdr.detectChanges();
  }

  // private method
  private isThemeLayout(layout: string) {
    this.currentLayout = layout;
  }

  // Close the mobile sidebar when crossing up to desktop width
  // (orientation change / window resize). Width check means mobile-browser
  // address-bar resizes (height-only) never affect the menu.
  @HostListener('window:resize')
  onResize(): void {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth >= 1025 && this.navCollapsedMob) {
      this.navCollapsedMob = false;
    }
  }

  // public method
  // State is the single source of truth — ngClass owns the mob-open class.
  navMobClick() {
    this.navCollapsedMob = !this.navCollapsedMob;
    if (document.querySelector('app-navigation.pc-sidebar')?.classList.contains('navbar-collapsed')) {
      document.querySelector('app-navigation.pc-sidebar')?.classList.remove('navbar-collapsed');
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.navCollapsedMob = false;
  }
}
